import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PresentIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.25 9.78053V6.73053H8.75V9.78053C8.75 9.89099 8.83954 9.98053 8.95 9.98053H13.8C13.9105 9.98053 14 9.89099 14 9.78053V7.73053H15V6.73053C15 6.17825 14.5523 5.73053 14 5.73053H12H11.5002C11.814 5.3127 12 4.79333 12 4.23053V4.10553C12 2.79385 10.9367 1.73053 9.625 1.73053C8.99639 1.73053 8.42483 1.97474 8 2.37347C7.57517 1.97474 7.00361 1.73053 6.375 1.73053C5.06332 1.73053 4 2.79385 4 4.10553V4.23053C4 4.79333 4.18597 5.3127 4.49982 5.73053H4H2C1.44772 5.73053 1 6.17825 1 6.73053V7.73053H2V9.78053C2 9.89099 2.08954 9.98053 2.2 9.98053H7.05C7.16046 9.98053 7.25 9.89099 7.25 9.78053ZM5.5 4.10553C5.5 3.62228 5.89175 3.23053 6.375 3.23053C6.85825 3.23053 7.25 3.62228 7.25 4.10553V5.23053H6.5C5.94772 5.23053 5.5 4.78281 5.5 4.23053V4.10553ZM8.75 5.23053H9.5C10.0523 5.23053 10.5 4.78281 10.5 4.23053V4.10553C10.5 3.62228 10.1082 3.23053 9.625 3.23053C9.14175 3.23053 8.75 3.62228 8.75 4.10553V5.23053ZM13.8 11.4805C13.9105 11.4805 14 11.57 14 11.6805V13.7305C14 14.8351 13.1046 15.7305 12 15.7305H8.75V11.6805C8.75 11.57 8.83954 11.4805 8.95 11.4805H13.8ZM7.25 11.6805V15.7305H4C2.89543 15.7305 2 14.8351 2 13.7305V11.6805C2 11.57 2.08954 11.4805 2.2 11.4805H7.05C7.16046 11.4805 7.25 11.57 7.25 11.6805Z"
		/>
	</svg>
))
